<template>
  <div id="app" :class="pageClass">
    <Register :siteName="siteName" />
    <TopNav :activeIndex="activeIndex" :siteName="siteName" />
    <MinNav :activeIndex="activeIndex" :siteName="siteName" />
    <el-container>
      <router-view
        :siteName="siteName"
        class="contentdiv"
        @pageClass="pClass"
        @activeIndex="acIndex"
      />
    </el-container>
    <Footer />
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue';
import MinNav from '@/components/MinNav.vue';
import Footer from '@/components/Footer.vue';
import Register from '@/components/Register.vue';
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    TopNav,
    MinNav,
    Footer,
    Register,
  },
  mounted() {
    this.$store.dispatch('toGetCurrentUser');
  },
  data() {
    return {
      isRouterAlive: true,
      siteName: '中国经济学年会投稿报名系统',
      activeIndex: '1',
      pageClass: 'home',
      openRegisterBox: false,
      openLoginBox: false,
    };
  },
  methods: {
    pClass(data) {
      this.pageClass = data;
    },
    acIndex(data) {
      this.activeIndex = data;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
